
// Cutoms filter auto sectlect script

document.addEventListener('DOMContentLoaded', () => {
  const url = new URL(window.location.href);

  if (!url.searchParams.has('filter.v.availability')) {
    url.searchParams.set('filter.v.availability', '1');
    window.location.replace(url.toString());
  }
});